import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { maskPhone, maskLandline } from 'util/masks'
import { createContact, getContact, getContactList, updateContact } from './redux/actions'

const initialState = { type: 'whatsapp', value: '' }
const ContactForm: React.FC<{ person?: number }> = ({ person }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [isFetching, setFetching] = useState(false)
  const [form, setForm] = useState(initialState)
  const isFormValid = !!(form.type && form.value)

  const { personId: routePerson, contactId: id } = useParams<{ personId: string, contactId: string }>()
  const inpRef = useRef<HTMLInputElement>(null)

  const personId = routePerson || person

  function handleClear (): void {
    setForm(initialState)
    history.push(person ? '/panel/profile' : `/panel/person/${personId}/contact`)
  }

  async function handleForm (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    setFetching(true)
    if (personId && id) {
      await updateContact(personId, id, form)(dispatch)
    } else if (personId) {
      await createContact(personId, form)(dispatch).then(res => {
        if (res?.status === 'success') {
          setForm(initialState)
        }
        return res
      })
    }
    setFetching(false)
  }

  useEffect(() => {
    if (personId) {
      getContactList(personId)(dispatch)
    }
  }, [dispatch, personId])

  useEffect(() => {
    if (personId && id) {
      getContact(personId, id)(dispatch).then((res) => {
        if (res?.status === 'success' && res?.data) {
          setForm({ type: res.data.type, value: res.data.value })
          inpRef.current?.focus()
        }
      })
    } else {
      setForm(initialState)
    }
  }, [dispatch, personId, id, inpRef])

  return (
    <form className="row justify-start variant-responsive" onSubmit={handleForm}>
      {
        id
          ? <h2>Edição de Contato</h2>
          : <h2>Cadastro de Contato</h2>
      }

      <div className="form-control">
        <label>Tipo de Contato</label>
        <select
          value={form.type}
          onChange={(e): void => setForm({ ...form, type: e.target.value })}
          required
        >
          <option value="whatsapp">WhatsApp</option>
          <option value="telegram">Telegram</option>
          <option value="phone">Celular</option>
          <option value="landline">Telefone Residencial</option>
          <option value="workphone">Telefone Comercial</option>
          <option value="facebook">Facebook</option>
          <option value="instagram">Instagram</option>
          <option value="twitter">Twitter</option>
          <option value="linkedin">LinkedIn</option>
          <option value="website">Site</option>
          <option value="e-mail">E-mail</option>
        </select>
      </div>
      <div className="form-control">
        <label>Contato</label>
        <input
          type="text"
          value={form.value}
          ref={inpRef}
          onChange={(e): void => {
            let value = e.target.value
            switch (form.type) {
              case 'whatsapp': value = maskPhone(e.target.value); break
              case 'telegram': value = maskPhone(e.target.value); break
              case 'phone': value = maskPhone(e.target.value); break
              case 'landline': value = maskLandline(e.target.value); break
              case 'workphone': value = maskLandline(e.target.value); break
            }
            setForm({ ...form, value })
          }}
          required
        />
      </div>
      <div className="form-control justify-end responsive-btn">
        <span
          onClick={handleClear}
          style={{ width: 300 }}
          className="button secondary margin-right-8"
        >
          Limpar
        </span>
        <button className="primary" style={{ width: 300 }} disabled={!isFormValid || isFetching}>
          {isFetching ? 'Processando...' : (id ? 'Atualizar' : 'Cadastrar')}
        </button>
      </div>
    </form>
  )
}

export default ContactForm
